export default {
  verification:{
    title:'请输入邮箱地址',
    phone:'手机',
    email:'邮箱',
    btn:'发送验证码',
    modalTitle:'请输入验证码',
    emailplaceholder:'请输入邮箱地址',
    bnnameplaceholder:'请输入推荐人或者BD姓名（选填）',
    bnnameplaceholder2:'请输入推荐人或者BD姓名',
    modalBtn:'确认',
  }
}
